<a class="explainer-banner" (click)="doLinkClick($event)" *transloco="let t"
  [attr.aria-label]="cta_label ? cta_label : t('call_to_action.'+cta_type)">
  <div class="row">
    <div class="col-lg-3">
      <div class="thumbnail">
        <button class="btn-play">
          <i class="fa-solid fa-circle-play"></i>
        </button>

        @if (image()) {
          <img
            [src]="image() | imageUrl:imageTransformations"
            [alt]="image()?.alt_text ?? 'A background image suggesting wisdom'">
        }
      </div>
    </div>
    <div class="content col-lg-9">
      <p class="h4 font-weight-bold">{{titleText}}</p>
      <p>{{description}}</p>
      @if (alertText) {
        <div class="alert alert-success mt-2" role="alert">
          <strong>{{alertText}}</strong>
        </div>
      }
      @if (cta_label || cta_type) {
        <button type="button" class="btn btn-primary btn-sm"
          [attr.aria-label]="cta_label ? cta_label : t('call_to_action.'+cta_type)">
          {{cta_label ? cta_label : t('call_to_action.'+cta_label)}}
        </button>
      }
    </div>
  </div>
</a>